import * as StorageConstants from '@/constants/storage-constants'
import IConfigurationModel, { ConfigurationModel } from '@/models/configuration-model';
import SentrySingleton from '@/singletons/sentry-singleton';

export default class FavoriteService {

    save(configuration: IConfigurationModel, index: number) {
        try {
            localStorage.setItem(StorageConstants.fullorderCombinations + index, JSON.stringify(configuration))
        }
        catch (err) {
            // on some browser like LINE, there is no localstorage; ignore that error
            console.error(err)
        }
    }

    load(index: number): IConfigurationModel {
        try {
            const config = localStorage && localStorage.getItem(StorageConstants.fullorderCombinations + index)
            return config ? JSON.parse(config) as IConfigurationModel : new ConfigurationModel()
        }
        catch (err) {
            // on some browser like LINE, there is no localstorage; ignore that error
            console.error(err)
            return new ConfigurationModel()
        }
    }

    determineDisableds(combinationLength: number): Array<boolean> {
        let disableds = [] as Array<boolean>
        try {
            for (let i = 0; i < combinationLength; i++) {
                const config = localStorage.getItem(StorageConstants.fullorderCombinations + i)
                if (config) {
                    disableds.push(JSON.parse(config ?? "") ? false : true)
                }
                else {
                    disableds.push(true)
                }

            }
        }
        catch (err) {
            SentrySingleton.instance.captureException(err)
        }


        return disableds
    }
}